var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("a-icon", { staticClass: "a-icon", attrs: { type: "plus-circle" } }),
      !_vm.disabled
        ? _c(
            "div",
            { staticClass: "ant-input", on: { click: _vm.openModal } },
            [
              _vm._l(_vm.ids, function (tag) {
                return [
                  _c(
                    "a-tooltip",
                    { key: tag.tagId, attrs: { title: tag.tagName } },
                    [
                      _c(
                        "a-tag",
                        {
                          key: tag.tagId,
                          staticStyle: { margin: "3px" },
                          attrs: { closable: true },
                          on: {
                            close: function () {
                              return _vm.tagClose(tag)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(tag.tagName) + " ")]
                      ),
                    ],
                    1
                  ),
                ]
              }),
              _c(
                "a-tooltip",
                { key: 1000001, attrs: { title: "删除全部" } },
                [
                  _c(
                    "a-tag",
                    {
                      key: 1000001,
                      staticStyle: { margin: "3px" },
                      attrs: { visible: _vm.ids.length > 0 },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.closeAll.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(" 删除全部 ")]
                  ),
                ],
                1
              ),
            ],
            2
          )
        : _c(
            "div",
            {
              staticClass: "ant-input",
              staticStyle: {
                height: "auto",
                "min-height": "32px",
                "background-color": "#eee",
              },
            },
            [
              _vm._l(_vm.list, function (tag) {
                return [
                  _c(
                    "a-tooltip",
                    { key: tag.tagId, attrs: { title: tag.tagName } },
                    [
                      _c(
                        "a-tag",
                        {
                          key: tag.tagId,
                          staticStyle: { margin: "3px" },
                          attrs: { closable: false },
                          on: {
                            close: function () {
                              return _vm.tagClose(tag)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(tag.tagName) + " ")]
                      ),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          ),
      _c(
        "a-modal",
        {
          attrs: {
            forceRender: "",
            title: _vm.title,
            width: 1200,
            "ok-text": "确认",
            "cancel-text": "取消",
          },
          on: { ok: _vm.handleOk },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c("div", { staticClass: "tag-select" }, [
            _c(
              "div",
              { staticClass: "tag-menu" },
              [
                _c(
                  "a-menu",
                  {
                    staticStyle: { width: "200px" },
                    attrs: {
                      defaultOpenKeys: [1, 2],
                      mode: "inline",
                      selectable: false,
                    },
                    on: { click: _vm.handleClick },
                  },
                  _vm._l(_vm.tagList, function (item) {
                    return _c(
                      "a-sub-menu",
                      { key: item.groupId },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "title" }, slot: "title" },
                          [_c("span", [_vm._v(_vm._s(item.groupName))])]
                        ),
                        _vm._l(item.children, function (child) {
                          return _c("a-menu-item", { key: child.groupId }, [
                            _vm._v(" " + _vm._s(child.groupName) + " "),
                          ])
                        }),
                      ],
                      2
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "ul",
              { staticClass: "tag-list" },
              _vm._l(_vm.tagList, function (item) {
                return _c("li", { key: item.groupId }, [
                  false ? _c("h3", [_vm._v(_vm._s(item.groupName))]) : _vm._e(),
                  _c(
                    "ul",
                    { staticClass: "child-list" },
                    _vm._l(item.children, function (child) {
                      return _c(
                        "li",
                        { key: child.groupId, class: "group" + child.groupId },
                        [
                          _c("h4", [_vm._v(_vm._s(child.groupName))]),
                          _c(
                            "ul",
                            _vm._l(child.tagList, function (tag) {
                              return _c(
                                "li",
                                {
                                  key: tag.tagId,
                                  class: { active: tag.checked },
                                  on: {
                                    click: function ($event) {
                                      tag.checked = !tag.checked
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(tag.tagName) + " ")]
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              }),
              0
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }